import propTypes from 'prop-types';
import React from 'react';

const HistoryItem = ({ amount, datetime, status }) => (
  <div className="withdrawal-history__item withdrawal-history-record">
    <span className="withdrawal-history-record__icon icon icon--withdraw" />
    <span className="withdrawal-history-record__amount">
      £{amount}
    </span>
    <span className="withdrawal-history-record__date">
      {datetime}
    </span>
    <span
      className={`withdrawal-history-record__status withdrawal-history-record__status--${status.toLowerCase()}`}
    >
      {status.toLowerCase()}
    </span>
  </div>
);

HistoryItem.propTypes = {
  amount: propTypes.string.isRequired,
  datetime: propTypes.string.isRequired,
  status: propTypes.string.isRequired
};

export default HistoryItem;
